import { SVGAttributes } from 'react'

const NavigateUpIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 20 12" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5827e-08 8.99561C3.68746e-08 8.90776 0.0390433 8.81991 0.117131 8.73206L9.69253 0.105419C9.77713 0.0351411 9.87799 1.07147e-06 9.99512 1.07286e-06C10.1122 1.07426e-06 10.2131 0.0351411 10.2977 0.105419L19.8731 8.73206C19.9577 8.80234 20 8.89165 20 9C20 9.10835 19.9577 9.19766 19.8731 9.26794L16.9546 11.8946C16.8765 11.9649 16.7773 12 16.6569 12C16.5365 12 16.4373 11.9649 16.3592 11.8946L9.99512 6.16691L3.63104 11.8946C3.55295 11.9649 3.45372 12 3.33333 12C3.21295 12 3.11371 11.9649 3.03563 11.8946L0.117131 9.26794C0.0390433 9.18009 3.47096e-08 9.08931 3.5827e-08 8.99561Z"
        />
    </svg>
)
export default NavigateUpIcon
